import React from 'react';
import './Banner.css';
import logo from '../assets/images1/AJKU-Logo-v1.png';


const Banner = () => {
  return (
    <div className="banner">
        <img src={logo} alt="Traditional Kyokushin Karate Logo" className="logo" />
        <span className="brand-name">Kyokushin Karate South Australia</span>
       
    </div>
  );
};

export default Banner;
